module.exports = __webpack_public_path__ + "img/3@s.b29b1ca6.jpg";